import { render } from "./HeadingOverviewHome.vue?vue&type=template&id=8d17d96c&scoped=true"
import script from "./HeadingOverviewHome.vue?vue&type=script&lang=js"
export * from "./HeadingOverviewHome.vue?vue&type=script&lang=js"

import "./HeadingOverviewHome.vue?vue&type=style&index=0&id=8d17d96c&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d17d96c"]])

export default __exports__